module.exports = __webpack_public_path__ + "static/img/Honda_ROBOTS_0020_18_D18_4.fa6046e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Honda_ROBOTS_0020_18_D18_4.jpg
// module id = UHC2
// module chunks = 0